"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderOptions = void 0;
var GenderOptions;
(function (GenderOptions) {
    GenderOptions["FEMALE"] = "female";
    GenderOptions["MALE"] = "male";
    GenderOptions["NOT_SPECIFIED"] = "not_specified";
})(GenderOptions || (exports.GenderOptions = GenderOptions = {}));
